import unionBy from 'lodash/unionBy';

import { IDepartment } from 'src/utilities/useSearchHooks';
import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';

// Interface for transformToOptions parameters
export interface TransformToOptionsParams {
  departments: IDepartment[];
}

// Interface for combineDepartments parameters
export interface CombineDepartmentsParams {
  resultsList: IDepartment[];
  fetchedDepartment: IDepartment | null;
  hasSearchQuery: boolean;
}

// Helper function to transform departments to dropdown options
export const transformToOptions = ({
  departments,
}: TransformToOptionsParams): DropdownOptionProps[] =>
  departments.map(({ id: value, name: text }) => ({
    value,
    text,
  }));

// Helper function to combine departments based on search state
export const combineDepartments = ({
  resultsList,
  fetchedDepartment,
  hasSearchQuery,
}: CombineDepartmentsParams): IDepartment[] => {
  const fetchedDepartments =
    hasSearchQuery || !fetchedDepartment ? [] : [fetchedDepartment];
  return unionBy(resultsList, fetchedDepartments, 'id');
};
